<template>
  <div class="down_goods_confirm">
    <!-- <van-icon name="cross" class="cross" @click="close" /> -->
    <div class="warning_img">!</div> 
    <div class="tit">商品上架48小时内不支持自主下架</div>
    <p class="desc">如有需要请联系客服处理</p>
    <div class="btns">
      <van-button round color="var(--theme)" class="back_btn" @click="close">知道了</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  props: {
    selection: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.$emit('closeModal')
    },
  }
}
</script>

<style lang="less" scoped>
.down_goods_confirm {
  position: relative;
  padding: 2rem 1.5rem 2.2rem;
  .warning_img {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size: 2rem;
    font-weight: 700;
    margin: 0 auto 1rem;
    display: block;
    color: #fff;
    background-color: var(--theme);
    border-radius: 50%;
  }
  .cross {
    position: absolute;
    right: .8rem;
    top: .8rem;
    font-size: 1.8rem;
    color: #000;
    cursor: pointer;
  }

  .tit {
    font-size: 1.6rem;
    text-align: center;
    font-weight: 700;
    color: var(--theme);
  }
  .desc {
    font-size: 1.4rem;
    text-align: center;
    color: #999;
    margin: 1.5rem 0;
  }
  .btns {
    display: flex;
    justify-content: center;

    .van-button {
      width: 100%;
      height: 3.2rem;
      padding: 0;
      font-size: 1.4rem;
    }

    .back_btn {
      border-color: #999;
      color: #999;
    }
  }
}
</style>